import {CommonModule} from '@angular/common';
import {NgModule, ModuleWithProviders} from '@angular/core';
import {LaImageComponent} from './la-image.component';

export {LaImageComponent} from './la-image.component';

// Export module's public API

@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [LaImageComponent],
  declarations: [LaImageComponent]
})
export class LaImageModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaImageModule,
      providers: []
    };
  }
}
